import React from "react";
import { Form, Input, Row, Col, Card, Typography, Button, Select, InputNumber, Space } from "antd";
import { PlusOutlined, MinusCircleOutlined, ShopOutlined, MedicineBoxOutlined } from "@ant-design/icons";

const { Title } = Typography;
const { TextArea } = Input;
const { Option } = Select;

interface ServicesTabProps {
  form: any;
}

export const ServicesTab: React.FC<ServicesTabProps> = ({ form }) => {
  return (
    <div>
      <Title level={4}>
        <ShopOutlined style={{ marginRight: '8px' }} />
        Services & Einrichtungen
      </Title>
      
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Card title="Restaurants & Gastronomie" size="small">
            <Form.List name={['content', 'services']}>
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <Card 
                      key={key} 
                      size="small" 
                      style={{ marginBottom: '16px' }}
                      extra={
                        <Button 
                          type="text" 
                          danger 
                          icon={<MinusCircleOutlined />}
                          onClick={() => remove(name)}
                        />
                      }
                    >
                      <Row gutter={[8, 8]}>
                        <Col span={12}>
                          <Form.Item
                            {...restField}
                            name={[name, 'name']}
                            label="Name"
                            rules={[{ required: true, message: 'Bitte geben Sie einen Namen ein' }]}
                          >
                            <Input placeholder="z.B. Gasthaus zur Sonne" />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            {...restField}
                            name={[name, 'type']}
                            label="Typ"
                            rules={[{ required: true, message: 'Bitte wählen Sie einen Typ' }]}
                          >
                            <Select placeholder="Typ auswählen">
                              <Option value="restaurant">Restaurant</Option>
                              <Option value="cafe">Café</Option>
                              <Option value="bar">Bar</Option>
                              <Option value="bakery">Bäckerei</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            {...restField}
                            name={[name, 'distance']}
                            label="Entfernung"
                          >
                            <Input placeholder="z.B. 2 min zu Fuß" />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            {...restField}
                            name={[name, 'rating']}
                            label="Bewertung"
                          >
                            <InputNumber 
                              min={0} 
                              max={5} 
                              step={0.1} 
                              style={{ width: '100%' }}
                              placeholder="4.5"
                            />
                          </Form.Item>
                        </Col>
                        <Col span={24}>
                          <Form.Item
                            {...restField}
                            name={[name, 'description']}
                            label="Beschreibung"
                          >
                            <TextArea 
                              rows={2} 
                              placeholder="Kurze Beschreibung des Restaurants..."
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            {...restField}
                            name={[name, 'phone']}
                            label="Telefon"
                          >
                            <Input placeholder="0123 456789" />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            {...restField}
                            name={[name, 'address']}
                            label="Adresse"
                          >
                            <Input placeholder="Hauptstraße 45" />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Card>
                  ))}
                  <Form.Item>
                    <Button 
                      type="dashed" 
                      onClick={() => add()} 
                      block 
                      icon={<PlusOutlined />}
                    >
                      Restaurant hinzufügen
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: '16px' }}>
        <Col span={24}>
          <Card title="Ärzte & Apotheken" size="small">
            <Form.List name={['content', 'medicalServices']}>
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <Card 
                      key={key} 
                      size="small" 
                      style={{ marginBottom: '16px' }}
                      extra={
                        <Button 
                          type="text" 
                          danger 
                          icon={<MinusCircleOutlined />}
                          onClick={() => remove(name)}
                        />
                      }
                    >
                      <Row gutter={[8, 8]}>
                        <Col span={12}>
                          <Form.Item
                            {...restField}
                            name={[name, 'name']}
                            label="Name"
                            rules={[{ required: true, message: 'Bitte geben Sie einen Namen ein' }]}
                          >
                            <Input placeholder="z.B. Dr. med. Schmidt" />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            {...restField}
                            name={[name, 'type']}
                            label="Typ"
                            rules={[{ required: true, message: 'Bitte wählen Sie einen Typ' }]}
                          >
                            <Select placeholder="Typ auswählen">
                              <Option value="doctor">Arzt</Option>
                              <Option value="pharmacy">Apotheke</Option>
                              <Option value="hospital">Krankenhaus</Option>
                              <Option value="dentist">Zahnarzt</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            {...restField}
                            name={[name, 'distance']}
                            label="Entfernung"
                          >
                            <Input placeholder="z.B. 10 min zu Fuß" />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            {...restField}
                            name={[name, 'phone']}
                            label="Telefon"
                          >
                            <Input placeholder="0123 456789" />
                          </Form.Item>
                        </Col>
                        <Col span={24}>
                          <Form.Item
                            {...restField}
                            name={[name, 'address']}
                            label="Adresse"
                          >
                            <Input placeholder="Hauptstraße 45" />
                          </Form.Item>
                        </Col>
                        <Col span={24}>
                          <Form.Item
                            {...restField}
                            name={[name, 'description']}
                            label="Beschreibung"
                          >
                            <TextArea 
                              rows={2} 
                              placeholder="Spezialisierung oder besondere Hinweise..."
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Card>
                  ))}
                  <Form.Item>
                    <Button 
                      type="dashed" 
                      onClick={() => add()} 
                      block 
                      icon={<PlusOutlined />}
                    >
                      Arzt/Apotheke hinzufügen
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </Card>
        </Col>
      </Row>
    </div>
  );
}; 